const setFloatHeight = () => {
  const float = document.getElementById('js-float');
  const height = float ? float.offsetHeight : 0;
  document.documentElement.style.setProperty('--float-height', `${height}px`);
}

const init = () => {
  const div = document.createElement('div');
  div.style.overflow = 'scroll';
  div.style.visibility = 'hidden';
  document.body.appendChild(div);
  const scrollbarWidth = div.offsetWidth - div.clientWidth;
  document.body.removeChild(div);
  document.documentElement.style.setProperty('--scrollbar', `${scrollbarWidth}px`);
  setFloatHeight();
}

const resize = () => {
  setFloatHeight();
}

const resizeW = () => {
  const div = document.createElement('div');
  div.style.overflow = 'scroll';
  div.style.visibility = 'hidden';
  document.body.appendChild(div);
  const scrollbarWidth = div.offsetWidth - div.clientWidth;
  document.body.removeChild(div);
  document.documentElement.style.setProperty('--scrollbar', `${scrollbarWidth}px`);
}

const scroll = () => {
}

export {
  init,
  resize,
  resizeW,
  scroll,
};